var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addDoc } from 'firebase/firestore';
import { useCallback } from 'react';
import { JobStatus } from 'libs.jobs.common';
import { useJobsCollection } from './use_jobs_collection.hook';
export function useCreateJob() {
    const { collection, user } = useJobsCollection();
    const createJob = useCallback((type, data) => __awaiter(this, void 0, void 0, function* () {
        if (!collection || !user) {
            console.error("Internal error: using the function before it's ready");
            return;
        }
        const jobId = yield addDoc(collection, Object.assign(Object.assign({}, data), { user, status: JobStatus.NEW, type }));
        return jobId.id;
    }), [collection, user]);
    return createJob;
}
//# sourceMappingURL=use_create_job.hook.js.map